const giant_rat = (level) => {
  const handle = 'giant_rat';
  const types = ['beast', 'rat'];

  return {
    handle,
    types,
    level,
    getAbilityTrees: () => [
      {
        handle: 'giant_rat_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
        },
      },
    ],
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(1 + bound_level * 0.25 + Math.random() * 3),
      perception: Math.round(1 + bound_level * 0.5 + Math.random() * 3),
      mana: Math.round(1 + bound_level * 0.1 + Math.random() * 2),
      toughness: Math.round(1 + bound_level * 0.1),
      strength: Math.round(1 + bound_level * 0.15 + Math.random()),
      willpower: Math.round(1 + bound_level * 0.15 + Math.random()),
      dexterity: Math.round(1 + bound_level * 0.75 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => ['dps_close', 'tank', 'interference', 'support', 'dps_ranged'],
    getStarterEquipment: () => ({}),
    xpValue: level * 2,
    drops_gold: false,
    drops_equipment: false,
    bags: [],
    build: {
      ai: {
        priorities: ['dps_close', 'tank', 'interference', 'support', 'dps_ranged'],
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: {},
      equipped_abilities: [{ value: 'move' }, { value: 'melee_attack' }],
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = giant_rat;
